export default "__VITE_ASSET__CaOgb9PI__"